export default __webpack_public_path__ + "static/media/bar-waiting.4be85690.jpg";